{
  "en": {
    "login": {
      "loginPupil": {
        "activeSession": {
          "confirm": "Login",
          "text": "You are currently logged in as a teacher. To use the access link as a student, you will be logged out first.",
          "title": "Log out and log in as a student?"
        },
        "appHandoff": {
          "continueInBrowser": "Continue in browser",
          "openApp": "Open in app",
          "subtitle": "Open in the fobizz app?",
          "text": "If you have the fobizz app on this device, your classroom will open there directly. Otherwise, you can continue here in the browser."
        },
        "error": "Unfortunately, this code is not valid. Maybe you made a typo?",
        "instruction": "You will receive your access code from your teacher.",
        "logIn": "Log in",
        "subtitle": "Enter your 6-digit code here",
        "title": "Log in as a student"
      },
      "loginTemporaryPupil": {
        "classFull": "This classroom is unfortunately already full. Please contact your teacher.",
        "error": "This link is no longer valid.",
        "title": "Please wait, you will be logged in shortly..."
      }
    }
  }
}
